export const parseHtmlTags = (htmlString: string) => {
  return htmlString.replace(/<[^>]+>/g, '')
}

export const convertHtmlSpace = (htmlString: string) => {
  return htmlString.replace(/&nbsp;/g, ' ')
}

export const convertHTMLLinkBreaks = (htmlString: string) => {
  return htmlString.replace(/<br\s*\/?>/g, '\n')
}

export const convertHTMLParagraphBreaks = (htmlString: string) => {
  return htmlString.replace(/<p>/g, '').replace(/<\/p>/g, '\n\n')
}

export const appendHttpsToUrl = (url: string) => {
  return `https:${url}`
}

export const formatIntoTwoDigits = (seconds: number): string => {
  switch (true) {
    case seconds <= 0:
      return '00'
    case seconds < 10:
      return seconds.toString().padStart(2, '0')
    default:
      return `${seconds}`
  }
}

export const formatSecsToTimeDisplay = (totalSeconds: number) => {
  if (totalSeconds < 0) {
    return ''
  }
  const minutes = Math.floor(totalSeconds / 60)
  const remainingSeconds = Math.floor(totalSeconds - minutes * 60)
  const secondsStr = formatIntoTwoDigits(remainingSeconds)
  const minutesStr = formatIntoTwoDigits(minutes)
  return `${minutesStr}:${secondsStr}`
}

export const getMediaTimeDisplay = (currentTime: number, duration: number): string => {
  return `${formatSecsToTimeDisplay(currentTime)} / ${formatSecsToTimeDisplay(duration)}`
}
